import { Grid } from "@chakra-ui/react";
import {
  MotionBox as Box,
  viewAppearDefault,
  staggeredAppear,
} from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";

export default function TextHeader({
  page,
  title,
  description,
  inverted,
  noAnimation,
  templateColumns,
  bg,
  mx,
  containerProps,
}) {
  return (
    <Box width="100%" bg={bg || (inverted ? "black.900" : "white")}>
      <Container small centerContent mx={mx} {...containerProps}>
        <Grid
          width="100%"
          templateColumns={templateColumns || ["1fr", null, "0.75fr 0.25fr"]}
          mx={0}
          mt="xxxl"
        >
          <Box
            variants={staggeredAppear}
            initial={noAnimation ? "visible" : "hidden"}
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
          >
            {page ? (
              <Text
                variants={viewAppearDefault}
                type="title_md"
                textTransform="uppercase"
                color="primary"
                mb={[2, null, "12px"]}
              >
                {page}
              </Text>
            ) : null}
            {title ? (
              <Text
                type="headline_md"
                variants={viewAppearDefault}
                textTransform="uppercase"
                color={inverted ? "white" : "black.900"}
                mb={[4, null, "md"]}
              >
                {title}
              </Text>
            ) : null}
            {description ? (
              <Text
                type="p_lg"
                variants={viewAppearDefault}
                color={inverted ? "white" : "black.900"}
              >
                {description}
              </Text>
            ) : null}
          </Box>
        </Grid>
      </Container>
    </Box>
  );
}
